/**
 * 统一错误类型（共享层）。
 *
 * ⚠️ 分层约束：`shared/` 必须**自包含**，只允许**相对路径**导入 `shared/` 内部文件。
 * 因 `web/server/tsconfig.json` 的 `include` 覆盖了 `shared/` 下全部 `.ts` 但**无 `paths`**，
 * 任何 `@/…` / `@shared/…` 别名都会让 server 侧 `tsc` 报 `TS2307`。
 *
 * `src/lib/result.ts` 由此处**再导出** `MeshLinkError`，业务侧导入路径保持不变。
 */

import { errorCatalog, type ErrorAction, type ErrorCode } from './errors';

export class MeshLinkError extends Error {
  public readonly code: ErrorCode;
  public readonly action: ErrorAction;
  public override readonly cause?: unknown;

  constructor(code: ErrorCode, message?: string, cause?: unknown, action?: ErrorAction) {
    super(message ?? errorCatalog[code].text);
    this.name = 'MeshLinkError';
    this.code = code;
    this.cause = cause;
    this.action = action ?? errorCatalog[code].action;
    // 保持 instanceof 在 ES5/ES2022 target 下均可用
    Object.setPrototypeOf(this, MeshLinkError.prototype);
  }

  /** 人话文案（UI 唯一可展示文本）。 */
  get userMessage(): string {
    return errorCatalog[this.code].text;
  }

  /** 序列化为可跨层传递的普通对象。 */
  toJSON(): { code: ErrorCode; message: string; action: ErrorAction } {
    return { code: this.code, message: this.userMessage, action: this.action };
  }
}
